import { Link } from '@tanstack/react-router'
import { Badge } from '@/components/ui/badge'
import {
  getHelpPath,
  getRelatedArticles,
  platformLabels,
  type DeviceKey,
} from '@/lib/help-center'

export function HelpArticleContent({
  slug,
  title,
  description,
  tags,
  devices,
  children,
}: {
  slug: string
  title: string
  description: string
  tags: string[]
  devices: DeviceKey[]
  children: React.ReactNode
}) {
  const related = getRelatedArticles(slug)

  return (
    <div className="grid gap-10 lg:grid-cols-[2.2fr_0.8fr]">
      <article className="space-y-8">
        <header className="space-y-3">
          <h2 className="text-2xl font-semibold text-slate-900">{title}</h2>
          <p className="text-slate-600">{description}</p>
          <div className="flex flex-wrap gap-2">
            {tags.map((tag) => (
              <Badge key={tag} variant="secondary">
                {tag}
              </Badge>
            ))}
          </div>
        </header>
        <div className="space-y-6 text-slate-700 leading-relaxed">{children}</div>
      </article>
      <aside className="space-y-6">
        <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
          <h3 className="text-lg font-semibold text-slate-900">Applies to</h3>
          <p className="text-sm text-slate-600 mt-2">
            These steps are tailored for the following devices.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {devices.map((device) => (
              <Badge key={device} className="bg-slate-900 text-white">
                {platformLabels[device]}
              </Badge>
            ))}
          </div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
          <h3 className="text-lg font-semibold text-slate-900">Related guides</h3>
          <ul className="mt-3 space-y-2 text-sm">
            {related.map((article) => (
              <li key={article.slug}>
                <Link
                  to={getHelpPath(article.slug)}
                  className="text-slate-700 hover:text-slate-900 underline"
                >
                  {article.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </aside>
    </div>
  )
}
